import React from "react";

import { useSelector } from "../../utils/hooks";

import { Product } from "./Product";

export const RecommendedProductsList = () => {
	const recommendedProducts = useSelector(
		(state) => state.popup.products.recommendedProducts.products,
	);

	const recommendedProductsHeader = useSelector(
		(state) => state.popup.recommendedProductsHeader,
	);

	return (
		<>
			{recommendedProducts.length > 0 && (
				<section className="recommended-product-wrapper">
					<h2 id="recommendedProducts__heading">
						{recommendedProductsHeader}
					</h2>

					<ul data-testid="products-list" className="recommended-products">
						{recommendedProducts.map(
							(product, i) => (
								<Product
									product={product}
									key={`${product.regionalProductSku}-${i}`}
									index={i}
								/>
							),
						)}
					</ul>
				</section>
			)}
		</>
	);
};
